import { render, staticRenderFns } from "./dingGroupTable.vue?vue&type=template&id=0d108d57&scoped=true"
import script from "./dingGroupTable.vue?vue&type=script&lang=js"
export * from "./dingGroupTable.vue?vue&type=script&lang=js"
import style0 from "./dingGroupTable.vue?vue&type=style&index=0&id=0d108d57&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d108d57",
  null
  
)

export default component.exports